import type { PublicOwnerBranding } from '@pay/shared';

// Toppen av kundesidene i eierens identitet: logo, ellers navnet, på eierens farge.
export function OwnerHeader({ owner }: { owner: PublicOwnerBranding }) {
  return (
    <header className="px-6 py-5" style={{ background: owner.primary_color || '#1f2937' }}>
      <div className="max-w-2xl mx-auto flex items-center gap-3">
        {owner.logo_url ? (
          <img src={owner.logo_url} alt={owner.name} className="h-12 max-w-[200px]" />
        ) : (
          <div className="text-white text-xl font-semibold">{owner.name}</div>
        )}
      </div>
    </header>
  );
}
